import { ReactElement } from "react";
import { DocumentGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { TimeZone } from "client/DateAndTime/timezones";
import { DocumentListItem } from "../../../Items/DocumentListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { generateTrackingId } from "client/Misc/utils";
import { useDocumentNavigationHandler } from "../../../Navigation/useDocumentNavigationHandler";

export type DocumentItemViewProps = {
	item: DocumentGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	onDismiss?(): void;
	isMobile: boolean;
	timezone: TimeZone;
	tabIndex: number;
};

export const DocumentItemView = (props: DocumentItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		onDismiss,
		isMobile,
		timezone,
		tabIndex
	} = props;

	const {
		document,
		hitHighlights
	} = item;

	const openHandler: () => void = useDocumentNavigationHandler({
		document,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("document-item", `|${itemIndex}`)}
			onClick={openHandler}
		>
			<DocumentListItem
				isMobile={isMobile}
				timezone={timezone}
				hitHighlights={hitHighlights}
				document={document}
				onDismiss={onDismiss}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};

DocumentItemView.displayName = "DocumentGlobalSearchItemView";

